import * as React from 'react';
import { translate } from 'react-i18next';
import * as s from './FirstTimeExperience.scss';
import Welcome from '../Welcome';
import InitialEditTeamDetails from '../InitialEditTeamDetails';
import { TeamDetailsState } from '../../redux/configure-store';
import { generateLearnMoreLink } from '../../consts/external-links';
import { ConnectedProps } from 'react-redux';
import { connector } from '.';

interface FirstTimeExperienceProps extends ConnectedProps<typeof connector> {}

class FirstTimeExperience extends React.Component<FirstTimeExperienceProps> {
  state = {
    showWelcome: true,
  };
  componentDidMount() {
    this.props.fetchCurrentUser();
    this.props.reportSetUpTeamLoad();
  }

  render() {
    const { setTeamDetails, currentUser, locale } = this.props;
    const { showWelcome } = this.state;
    const learnMoreLink = generateLearnMoreLink(locale);
    return (
      <div className={s.page}>
        <div className={s.leftColumn}>
          {showWelcome ? (
            <Welcome
              onStartClick={() => this.setState(() => ({ showWelcome: false }))}
              learnMoreLink={learnMoreLink}
            />
          ) : (
            <InitialEditTeamDetails
              onSave={(teamDetails: TeamDetailsState) =>
                setTeamDetails(teamDetails)
              }
              onBack={() => this.setState(() => ({ showWelcome: true }))}
              currentUser={currentUser}
              learnMoreLink={learnMoreLink}
            />
          )}
        </div>
      </div>
    );
  }
}

export default translate(null)(FirstTimeExperience);
